import React from 'react';
import { Link } from 'react-router-dom';
import { Ellipsis } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import './BottomNav.css';

/**
 * The phone tab bar (below 1024px): a floating glass pill hugging the bottom edge, like the
 * platform's. Four destinations for the signed-in role plus "More", which opens the drawer
 * (teachers get their four destinations and no "More"). Only the selected tab shows its label on a
 * phone; tablets have room for every label. The labels stay in the page for screen readers.
 *
 * tabs: [{ key, to, label, shortLabel, Icon, active }] — from useStaffNav() / useTeacherNav().
 */
function BottomNav({ tabs, showMore = false, onMore }) {
  const { t } = useI18n();
  return (
    <nav className="bnav" aria-label={t('layout.quickNav')}>
      <div className="bnav-bar">
        {tabs.map((tab) => {
          const { Icon } = tab;
          return (
            <Link
              key={tab.key}
              to={tab.to}
              className={`bnav-tab${tab.active ? ' active' : ''}`}
              aria-current={tab.active ? 'page' : undefined}
              title={tab.label}
            >
              <Icon strokeWidth={tab.active ? 2.4 : 2} aria-hidden="true" focusable="false" />
              <span className="bnav-label">{tab.shortLabel}</span>
            </Link>
          );
        })}
        {showMore && (
          <button type="button" className="bnav-tab" onClick={onMore} aria-haspopup="dialog" title={t('layout.more')}>
            <Ellipsis strokeWidth={2} aria-hidden="true" focusable="false" />
            <span className="bnav-label">{t('layout.more')}</span>
          </button>
        )}
      </div>
    </nav>
  );
}

export default BottomNav;
